import { Helmet } from 'react-helmet-async';
// import MainSection from '../components/hrm/mainSection/MainSection';
import HrmDetails from '../components/hrm/HrmDetails';
import MainSection from '@/components/MainSection';
import { useTranslation } from 'react-i18next';
import Hrm from '@/features/products/components/svg/Hrm';

export default function HrmPage() {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('hrMangementPage.mainTitle')}</title>
                <meta name="description" content={t('hrMangementPage.mainDesc')} />
                <link rel="canonical" href="/hr-management" />
            </Helmet>
            <div className="w-full mb-[100px] relative overflow-hidden ">
                <MainSection
                    title={t('hrMangementPage.mainTitle')}
                    description={t('hrMangementPage.mainDesc')}
                    icon={<Hrm />}
                />
            </div>

            <HrmDetails />
        </>
    );
}
